import { Component, computed, input } from '@angular/core';

type AlertType = 'success' | 'warning' | 'error' | 'info';

@Component({
  selector: 'zn-alert',
  standalone: true,
  templateUrl: './zn-alert.html',
  styleUrl: './zn-alert.scss',
})
export class ZnAlert {
  type = input<AlertType>('info');
  icon = input<string>('bi bi-exclamation-triangle-fill');
  title = input<string | null>(null);
  text = input<string | null>(null);

  alertClass = computed(() => {
    const map: Record<AlertType, string> = {
      success: 'alert-success',
      warning: 'alert-warning',
      error: 'alert-danger',
      info: 'alert-info',
    };

    return `alert ${map[this.type()]}`;
  });
}
